import React from "react";
import { EditPlanContextProvider } from "./EditPlanView";
import EditPlan from "./views/EditPlan";

const EditSubsrciptionPlanPage = () => {
  return (
    <div>
      <EditPlanContextProvider>
        <EditPlan />
      </EditPlanContextProvider>
    </div>
  );
};

export default EditSubsrciptionPlanPage;
